var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignedMessagesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sign_Message",
    "data-name": "Sign Message",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    opacity: 0.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4, 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M2087.916-606.749a1,1,0,0,1-.912-1.081,28.242,28.242,0,0,1,2.272-8.194,26.164,26.164,0,0,1,4.348-6.861,22.807,22.807,0,0,1,7.862-5.739l.146-.062c.246-.105.423-.182.582-.233a1.2,1.2,0,0,1,1.112.116,1.359,1.359,0,0,1,.471,1.325c0,.05-.006.105-.008.166v.008a32.456,32.456,0,0,1-.357,3.405.962.962,0,0,1-.016.107l-.007.034c-.77,4.631-2.555,8.166-5.327,10.536a13.2,13.2,0,0,1-8.659,3.111,20.28,20.28,0,0,0-.424,2.449,1,1,0,0,1-1,.916C2087.973-606.745,2087.944-606.747,2087.916-606.749Zm3.19-8.469a28.123,28.123,0,0,0-1.15,3.1,11.387,11.387,0,0,0,1.709-.2,10.913,10.913,0,0,0,5.14-2.452q.086-.074.171-.15c-.176.012-.357.018-.543.018a7.513,7.513,0,0,1-1.731-.2,1,1,0,0,1-.742-1.2,1,1,0,0,1,1.2-.742,6.532,6.532,0,0,0,3.8-.364l.04-.018q.047-.019.094-.033a15.226,15.226,0,0,0,1.457-3.091,6.944,6.944,0,0,1-1.775.437,1.04,1.04,0,0,1-.117.007,1,1,0,0,1-.992-.885,1,1,0,0,1,.877-1.109c.755-.088,2.534-.463,2.9-2.04q.189-1.149.289-2.4A21.748,21.748,0,0,0,2091.106-615.218Z",
    transform: "translate(-2080 630.254)",
    fill: "#27e8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M17420,20126.885a3,3,0,0,1-3-3V20114a3,3,0,0,1,3-3h13a1,1,0,0,1,0,2h-13a1,1,0,0,0-1,1v9.885a1,1,0,0,0,1,1h1.5a1,1,0,0,1,0,2Z",
    transform: "translate(-17417 -20111)",
    fill: "#27e8a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(5 4)",
    fill: "#27e8a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(5 7)",
    fill: "#27e8a7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedMessagesActive);
export default __webpack_public_path__ + "static/media/signed-messages-active.334a68b7.svg";
export { ForwardRef as ReactComponent };